import { Position } from "@xyflow/react";
import { BaseNodeProps } from "components/CC/Nodes/node-types";
import { BaseNode } from "components/CC/Nodes/NodeBase/BaseNode";
import { TransparentHandle } from "components/CC/UI/TransparentHandle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC, ReactNode } from "react";

export interface NodeConfig {
    color: string;
    title: string;
    icon: ReactNode;
    badge?: ReactNode;
    handles?: {
        left?: boolean;
        right?: boolean;
    };
}

export const createNode = (config: NodeConfig): FC<BaseNodeProps> => {
    const { color, title, icon, badge, handles = {} } = config;
    const { left = true, right = true } = handles;

    const NodeComponent: FC<BaseNodeProps> = ({ id, data }) => {
        const { t } = usePaldockTranslation("components.connection-creator");

        return (
            <div>
                <BaseNode id={id} data={data} color={color} label={t(title)} badge={badge}>
                    {icon}
                </BaseNode>
                {left && <TransparentHandle position={Position.Left} type="target" />}
                {right && <TransparentHandle position={Position.Right} type="source" />}
            </div>
        );
    };

    return NodeComponent;
};
